var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('RidersListIndex',{attrs:{"fst-id":"delete-requested-riders","pageTitle":_vm.$t('components.riderManagement.deleteRequestedRidersHeadline'),"qso":_vm.qso,"endpoint":_vm.endpoint,"type":"deleteRequestRiders"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }